import React, { useState, useEffect } from 'react';
import BootStrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import axios from './axios-config';
import swal from 'sweetalert';
import Moment from 'moment';
import $ from 'jquery';
import { Card, CardBody, CardHeader } from 'reactstrap';

const Pagination = () => {

  const [miVariable, setMiVariable] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [show, setShow]= useState(false);




useEffect(async() => {
  let datos=[];
  let mivaribleDep="";
  let parentesco="";




  axios.get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/dependientes/`+$('#certificado').val(),{
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
    },
  }).then(json => {
       if (json.status === 200) {

    if (json.data.tPolDependiente.length===undefined){

      /*if (json.data.tPolDependiente.parentesco==='1'){
      parentesco='Conyugue';

      }else{
      parentesco = 'Hij(@)';
      }*/
      parentesco=json.data.tPolDependiente.descripcionParentesco;

      var anio = json.data.tPolDependiente.fechaNacimiento.substring(0,4);
      var mes = json.data.tPolDependiente.fechaNacimiento.substring(5,7);
      var dia = json.data.tPolDependiente.fechaNacimiento.substring(8,10);

      var F = dia + '/' + mes + '/' + anio;
      let vNombreDep=json.data.tPolDependiente.primerNombre+' '+json.data.tPolDependiente.segundoNombre?json.data.tPolDependiente.segundoNombre:''
      +' '+json.data.tPolDependiente.primerApellido+' '+json.data.tPolDependiente.segundoApellido?json.data.tPolDependiente.segundoApellido:'';      
      mivaribleDep =[{ID:1,NOMBRES:vNombreDep, PARENTESCO:parentesco,FECHA:F}];

    }
    else{
  for (var i = 0; i < json.data.tPolDependiente.length; i++) {

  /*if (json.data.tPolDependiente[i].parentesco===1){
  parentesco='Conyugue';
  }else{
  parentesco = 'Hij(@)';
  }*/
  parentesco=json.data.tPolDependiente[i].descripcionParentesco;
  const fechaNacimiento = json.data.tPolDependiente[i].fechaNacimiento;
  const nuevaFechaNac = new Date(fechaNacimiento);
  //console.log('dentro de for 2',nuevaFechaNac);
  /*var anio = json.data.tPolDependiente[i].fechaNacimiento.substring(0,4);
  var mes = json.data.tPolDependiente[i].fechaNacimiento.substring(5,7);
  var dia = json.data.tPolDependiente[i].fechaNacimiento.substring(8,10);
  */
 const anio = nuevaFechaNac.getFullYear();
const mes = String(nuevaFechaNac.getMonth() + 1).padStart(2, '0');
const dia = String(nuevaFechaNac.getDate()).padStart(2, '0');
  

  var F = dia + '/' + mes + '/' + anio;
  //console.log('dependiente',json.data.tPolDependiente[i]);
    //datos.push({ID:i,NOMBRES:json.data.tPolDependiente[i].primerNombre+' '+json.data.tPolDependiente[i].primerApellido, PARENTESCO:parentesco,FECHA:Moment(d).format('L')});
      var vNombreDep=json.data.tPolDependiente[i].primerNombre+' '+(json.data.tPolDependiente[i].segundoNombre?json.data.tPolDependiente[i].segundoNombre:'')
      +' '+json.data.tPolDependiente[i].primerApellido+' '+ (json.data.tPolDependiente[i].segundoApellido?json.data.tPolDependiente[i].segundoApellido:'')
      +' '+(json.data.tPolDependiente[i].apellidoCasada?' DE '+json.data.tPolDependiente[i].apellidoCasada:'');
   var carne=json.data.tPolDependiente[i].carnet;
    datos.push({ID:i+1,NOMBRES:vNombreDep, PARENTESCO:parentesco,FECHA:F,CARNE:carne});
    }
  mivaribleDep = datos;
  


}
  setTimeout(
   function()
   {

  //console.log(mivaribleDep);
     //do something special
   }, 9000);
   setMiVariable(mivaribleDep);
       } else {
         swal("Aviso", "No se encontro información de Dependiente ", "info");
       }
     }).catch(function(error) {

     })


}, []);

const columns = [
  {
    dataField: 'ID',
    text: 'ID',
    headerAlign: 'center',
    align: 'center',
    headerStyle: { width: '70px' },
    style: { width: '70px' },
  },
  {
    dataField: 'NOMBRES',
    text: 'Nombres y Apellidos',
    headerStyle: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      fontSize: '0.85rem',
    },
    style: { whiteSpace: 'normal', wordBreak: 'break-word' },
  },
  {
    dataField: 'PARENTESCO',
    text: 'Parentesco',
    headerStyle: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      fontSize: '0.85rem',
    },
    style: { whiteSpace: 'normal', wordBreak: 'break-word' },
  },
  {
    dataField: 'FECHA',
    text: 'Fecha Nacimiento',
    headerAlign: 'center',
    align: 'center',
    headerStyle: { whiteSpace: 'nowrap' },
    style: { whiteSpace: 'nowrap' },
  },
  {
    dataField: 'CARNE',
    text: 'Carné',
    headerAlign: 'center',
    align: 'center',
    headerStyle: { whiteSpace: 'nowrap' },
    style: { whiteSpace: 'nowrap' },
  },
];

  return (
    <Card className="shadow-sm border-0 w-100">
      <CardHeader className="bg-white border-0 d-flex align-items-center">        
      </CardHeader>
      <CardBody className="pt-0">
        <div className="table-responsive">
          <table className="table mb-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th className="px-3 py-3 text-uppercase text-muted small fw-bold" style={{ width: '60px' }}>ID</th>
                <th
                  className="px-3 py-3 text-uppercase text-muted small fw-bold"
                  style={{ minWidth: '260px' }}
                >
                  Nombres y Apellidos
                </th>
                <th className="px-3 py-3 text-uppercase text-muted small fw-bold">Parentesco</th>
                <th className="px-3 py-3 text-uppercase text-muted small fw-bold">Nacimiento</th>
                <th className="px-3 py-3 text-uppercase text-muted small fw-bold text-end">
                  Carné
                </th>
              </tr>
            </thead>
            <tbody className="border-top-0">
              {miVariable.map((dep) => (
                <tr key={dep.ID} className="align-middle">
                  <td className="px-3 py-3 fw-semibold" style={{ width: '60px' }}>{dep.ID}</td>
                  <td className="px-3 py-3 text-uppercase" style={{ minWidth: '260px' }}>
                    {dep.NOMBRES}
                  </td>
                  <td className="px-3 py-3">{dep.PARENTESCO}</td>
                  <td className="px-3 py-3 text-muted">{dep.FECHA}</td>
                  <td className="px-3 py-3 text-end">
                    <span className="font-monospace text-body-secondary">
                      {dep.CARNE ?? ''}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};
export default Pagination;
